// import React, { useRef, useState, useEffect } from 'react';
// import { Play, Pause } from 'lucide-react';

// interface YouTubeVideoPlayerProps {
//   videoId: string; // YouTube video ID (e.g., "dQw4w9WgXcQ" from https://www.youtube.com/watch?v=dQw4w9WgXcQ)
//   width?: number;
//   height?: number;
// }

// const YouTubeVideoPlayer: React.FC<YouTubeVideoPlayerProps> = ({ 
//   videoId, 
//   width = 640, 
//   height = 360 
// }) => {
//   const playerRef = useRef<any>(null);
//   const containerRef = useRef<HTMLDivElement>(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [showThumbnail, setShowThumbnail] = useState(true);
//   const [player, setPlayer] = useState<any>(null);

//   // YouTube thumbnail URL
//   const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

//   useEffect(() => {
//     // Load YouTube IFrame API
//     if (!window.YT) {
//       const tag = document.createElement('script');
//       tag.src = 'https://www.youtube.com/iframe_api';
//       const firstScriptTag = document.getElementsByTagName('script')[0];
//       firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
//     }

//     // Initialize player when API is ready
//     const initializePlayer = () => {
//       if (window.YT && window.YT.Player) {
//         const newPlayer = new window.YT.Player(playerRef.current, {
//           width,
//           height,
//           videoId,
//           playerVars: {
//             controls: 0, // Hide default controls
//             modestbranding: 1,
//             rel: 0,
//             showinfo: 0,
//           },
//           events: {
//             onReady: (event: any) => {
//               setPlayer(event.target);
//             },
//             onStateChange: (event: any) => {
//               const state = event.data;
//               if (state === window.YT.PlayerState.PLAYING) {
//                 setIsPlaying(true);
//                 setShowThumbnail(false);
//               } else if (state === window.YT.PlayerState.PAUSED) {
//                 setIsPlaying(false);
//               }
//             },
//           },
//         });
//       }
//     };

//     if (window.YT && window.YT.Player) {
//       initializePlayer();
//     } else {
//       window.onYouTubeIframeAPIReady = initializePlayer;
//     }
//   }, [videoId, width, height]);

//   const togglePlayback = () => {
//     if (!player) return;

//     if (isPlaying) {
//       player.pauseVideo();
//     } else {
//       player.playVideo();
//       setShowThumbnail(false);
//     }
//   };

//   const handleThumbnailClick = () => {
//     if (player) {
//       player.playVideo();
//       setShowThumbnail(false);
//     }
//   };

//   return (
//     <div className="relative inline-block bg-black rounded-lg overflow-hidden shadow-lg">
//       <div 
//         className="relative cursor-pointer"
//         style={{ width, height }}
//         ref={containerRef}
//       >
//         {/* YouTube Player (hidden when showing thumbnail) */}
//         <div 
//           ref={playerRef}
//           className={`absolute inset-0 ${showThumbnail ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
//         />
        
//         {/* Custom Thumbnail Overlay */}
//         {showThumbnail && (
//           <div 
//             className="absolute inset-0 bg-cover bg-center cursor-pointer"
//             style={{ 
//               backgroundImage: `url(${thumbnailUrl})`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center'
//             }}
//             onClick={handleThumbnailClick}
//           >
//             {/* Dark overlay for better button visibility */}
//             <div className="absolute inset-0 bg-black bg-opacity-20" />
//           </div>
//         )}
        
//         {/* Custom Play/Pause Button */}
//         <button
//           onClick={togglePlayback}
//           className="absolute inset-0 flex items-center justify-center bg-transparent border-none cursor-pointer group"
//           style={{ zIndex: 10 }}
//         >
//           <div className="bg-black bg-opacity-70 rounded-full p-4 transition-all duration-200 group-hover:bg-opacity-90 group-hover:scale-110">
//             {isPlaying ? (
//               <Pause size={32} className="text-white" fill="white" />
//             ) : (
//               <Play size={32} className="text-white ml-1" fill="white" />
//             )}
//           </div>
//         </button>
//       </div>
//     </div>
//   );
// };
// export default V;

import React from 'react';
import ReactPlayer from 'react-player';
import styles from './index.module.scss';

interface VideoSectionProps {
  videoSrc: string;
  poster?: string; 
  className?: string;
}

const VideoSection: React.FC<VideoSectionProps> = ({ videoSrc, className }) => {
  return (
    <div className={`${styles.videoContainer} ${className || ''}`}>
      <ReactPlayer
        url={videoSrc}
        width="100%"
        height="100%"
        controls={true}
        // light={poster}
        playIcon={<button className={styles.playButton}>Play</button>}
      />
    </div>
  );
};

export default VideoSection;